import React from 'react';
import { Badge } from 'react-bootstrap';
import '../../styles/badge-styles.css';

/**
 * Enhanced Badge component with improved styling
 *
 * @param {Object} props - Component props
 * @param {string} props.bg - Badge background variant (success, primary, warning, danger, etc.)
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.pill - Whether to use pill styling
 * @param {boolean} props.small - Whether to use small styling
 * @param {boolean} props.count - Whether this is a count badge (for notifications)
 * @param {string} props.platform - Platform-specific styling (shopify, wix, wordpress)
 * @param {boolean} props.interactive - Whether the badge should have hover effects
 * @param {React.ReactNode} props.children - Badge content
 * @returns {JSX.Element} - Enhanced Badge component
 */
const CustomBadge = ({
  bg = 'primary',
  className = '',
  pill = false,
  small = false,
  count = false,
  platform = null,
  interactive = false,
  children,
  ...rest
}) => {
  // Build the custom class names
  const customClasses = [
    'custom-badge',
    platform ? `custom-badge-${platform.toLowerCase()}` : `custom-badge-${bg}`,
    pill ? 'custom-badge-pill' : '',
    small ? 'custom-badge-sm' : '',
    count ? 'custom-badge-count' : '',
    interactive ? 'custom-badge-interactive' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <Badge
      bg={platform ? undefined : bg}
      className={customClasses}
      pill={pill}
      {...rest}
    >
      {children}
    </Badge>
  );
};

export default CustomBadge;
